import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import { defaultEmailTemplates, defaultSmsTemplates,defaultNotifTemplates } from '@/assets/js/tempMessage.js'
import axios from 'axios'
import { useCustomerStore } from './customerStore';
import { useLeadStore } from './leadStore';
import { useNotificationStore } from './notificationStore';
import { useAccessControlStore } from './accessControlStore';
import { useAttachmentStore } from './attachmentStore';

export const useMessagingStore = defineStore('messagingStore', {
	state: () => ({
		message_profile: null,
		group_message_list: [],
		group_message_summaries: [],
		available_user_list: [],
		listParticipants: [],
		selected_group: null,
		refresh_bundle_key: null,
		sms_template_list: [],

		messages: null,
		messages_pagination: null,
		messages_length: null,
		replying_to: null,
		edit_message: null,
		loading_message: true,
		loading_search: false,
	}),
	getters: {
		available_participant_list() {
			const userIds = this.available_user_list.map(o => o.id)
			return this.listParticipants.filter((item) => userIds.includes(item.participant_user_id));
		},
		available_group_chat_list() {
			const activeUserId = _gAuth.activeUserId();
			const activeMsgGroupSuperAdminIds = _gAuth.activeCorpMsgGroupSuperAdminIds();
			var gList = [];

			if (_gAuth.isCorporateOwner() || activeMsgGroupSuperAdminIds.includes(activeUserId)) {
				gList = this.group_message_list
			} else {
				gList = this.group_message_list.filter((item) => {
					let allowView = (item.group_type == 'internal' && _gHlp.checkAccess(['role_external_user'])) ? false : true;
					return allowView && item.group_participants.some((child) => {
						return child.participant_user_id == activeUserId
					})
				});
			}

			//FILTER EMPTY OWN MESSAGE
			return gList.filter((item) => {
				return !((item.group_channel_type == 'PRIVATE') && (item.group_participants.length == 1) && (item.group_summary.total_messages <= 0))
			})
		}
	},
	actions: {
		/**
		 *[===========CHAT MESSAGE FEATURE===========]
		 *PUT ALL CODE ABOUT CHAT MESSAGE BELOW DON'T MIX WITH OTER MESSAGE FEATURE
		 */
		//MESSAGE DRAWER
		setActiveParticipant(user) {
			const createData = {
				participant_user_id: user.id,
				participant_username: user.name,
				participant_fullname: user.name,
				participant_photo_profile: null
			}

			axios.post(services.messaging + 'participant', createData, { headers: getHeader() })
				.then(response => {
					if (response.status === 201) {
						window.localStorage.setItem('auth_msg_participant', JSON.stringify(response.data))
					}
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					console.log('Messaging Store (Create New Participant) failed: ' + e.response.data.message)
				});

		},
		setMessageProfile(profile) {
			this.message_profile = profile
		},
		refreshMessageBox(bundle_key) {
			if (this.refresh_bundle_key != bundle_key) {
				this.refresh_bundle_key = bundle_key
			}
		},
		//GROUP MESSAGE
		setSelectedGroup(group) {
			this.selected_group = group
		},
		getGroupName(group) {
			if (group.group_channel_type == 'PUBLIC') {
				return group.group_name
			} else {
				let activeUserId = _gAuth.activeUserId();
				let oponent = group.group_participants.find(o => { return o.participant_user_id != activeUserId })
				if (_gHlp.isEmpty(oponent)) return group.group_name
				return oponent.participant_fullname
			}
		},
		getGroupCreator(group) {
			let activeUser = _gAuth.activeUser();
			if (group.group_created_by == activeUser.id) return activeUser.name

			const userList = useAccessControlStore().userList
			const creator = userList.find(o => o.id == group.group_created_by)

			if (!_gHlp.isEmpty(creator)) return creator.name

			return "---";
		},
		groupIsOwnChat(group) {
			const activeUser = _gAuth.activeUser();
			let selfParticipant = group.group_participants.find((p) => { return p.participant_user_id == activeUser.id })
			if (!_gHlp.isEmpty(selfParticipant) && (group.group_channel_type == 'PRIVATE') && (group.group_participants.length == 1)) {
				return true;
			}
			return false
		},
		getGroupMessageList(bundle_key) {
			this.group_message_list = []
			this.selected_group = null
			return new Promise((resolve, reject) => {
				let queryParams = _gHlp.generateQueryParams({
					paginate: 'no_paginate',
					search: {
						parent_bundle_key: bundle_key,
						show_external: true
					}
				})
				axios.get(services.messaging + 'group-messages?' + queryParams, { headers: getHeader() })
					.then(res => {
						if (!_gHlp.isEmpty(res.data) && !_gHlp.isEmpty(res.data.data)) {
							this.group_message_list = res.data.data;
							// this.selected_group = res.data.data[0];
						}
						resolve(this.group_message_list);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		getGroupMessageDetail(group_id = null) {
			this.messages = [];
			this.selected_group = null
			let queryParams = _gHlp.generateQueryParams({
				group_id: group_id,
				participant_id: _gAuth.activeMsgParticipantId()
			})
			return new Promise((resolve, reject) => {
				axios.get(services.messaging + 'group-message/detail?' + queryParams, { headers: getHeader() }).then(resp => {
					if (resp.status === 200) {
						this.selected_group = resp.data
						resolve(resp.data)
					} else {
						reject(null)
					}
				}).catch(err => {
					_gNotif.errorFunction(err)
					reject(err)
				})
			});
		},
		async createGroupMessage(params) {
			try {
				const response = await axios.post(services.messaging + 'group-message', params, { headers: getHeader() });
				if (response.status === 201) {
					this.selected_group = response.data
					return true;
				}
			} catch (e) {
				_gNotif.errorFunction(e)
				return false;
			}
		},
		async updateGroupMessage(id, params) {
			try {
				const response = await axios.post(services.messaging + 'group-message/' + id, params, { headers: getHeader() });
				if (response.status === 201) {
					this.selected_group = response.data
					return true;
				}
			} catch (e) {
				_gNotif.errorFunction(e)
				return false;
			}
		},
		checkUserGroup(user_id, bundle_key, profile_type, add_to_all_group = false) {
			const user = useAccessControlStore().getUser(user_id);
			let params = {
				user_id: user_id,
				parent_bundle_key: bundle_key,
				show_external: true,
				is_external_user: _gHlp.getValue(user, 'current_user_application.setting_json.is_external_staff', false),
				profile_type: profile_type,
				add_to_all_group: add_to_all_group,
			}
			return new Promise((resolve, reject) => {
				axios.post(services.messaging + 'group-message/check-user-group', params, { headers: getHeader() })
					.then(res => {
						resolve(res);
					})
					.catch(e => {
						_gNotif.errorFunction(e)
						reject(e)
					})
			});
		},
		//MESSAGE PARTICIPANTS
		async getAvailableUserByProfile() {
			if (!_gHlp.isEmpty(this.message_profile)) {
				switch (this.message_profile.type) {
					case 'customer':
					case 'proposal':
					case 'product':
						this.available_user_list = await useCustomerStore().getUserCanAccess(this.message_profile.customer_id);
						break;
					 case 'banker':
						this.available_user_list = await useCustomerStore().getUserCanAccess(this.message_profile.customer_id);
						if (this.message_profile.banker_user) {
							if(!this.available_user_list){
								this.available_user_list = [];
							}
							this.available_user_list.push(this.message_profile.banker_user);
						}	
						break;
					default:
						this.available_user_list = await useLeadStore().getUserCanAccess(this.message_profile.lead_id);
						break;
				}

				//EXCLUDE FROM ALL CHAT GROUP
				if (_gAuth.isAppSas()) {
					this.available_user_list = this.available_user_list.filter(o => !([31, 90, 23, 26, 2].includes(o.id)))
				}

			}
		},
		getListParticipant() {
			const localParticipants = _gHlp.getLocalStorage('srvMessaging.listParticipants');
			if (!_gHlp.isEmpty(localParticipants)) {
				this.listParticipants = localParticipants;
				return this.listParticipants;
			}

			return new Promise((resolve, reject) => {
				let queryParams = _gHlp.generateQueryParams({
					paginate: 'no_paginate'
				})
				let url = `${services.messaging}participants?${queryParams}`;
				axios.get(url, { headers: getHeader() })
					.then(res => {
						if (!_gHlp.isEmpty(res.data)) {
							this.listParticipants = !_gHlp.isEmpty(res.data.data) ? res.data.data : [];
							_gHlp.setLocalStorage('srvMessaging.listParticipants', this.listParticipants)
						} else {
							this.listParticipants = [];
						}
						resolve(this.listParticipants);
					})
					.catch(e => {
						reject(e);
					})
			})
		},

		//MESSAGES
		getMessages(group_id, total_paginate = 10) {
			this.loading_message = true
			this.messages = [];
			let queryParams = _gHlp.generateQueryParams({
				paginate: total_paginate,
				page: 0,
				orderBy: {
					message_id: 'desc'
				},
				search: {
					message_group_id: group_id,
					message_from_date: this.showOnlyFromDate()
				}
			})

			let url = `${services.messaging}messages?${queryParams}`;
			axios.get(url, { headers: getHeader() })
				.then(res => {
					if (!_gHlp.isEmpty(res.data)) {
						this.messages = !_gHlp.isEmpty(res.data.data) ? res.data.data : [];
						this.messages_length = res.data.meta.total
						this.messages_pagination = res.data.meta
					} else {
						this.messages = [];
						this.messages_length = 0
						this.messages_pagination = null
					}
					this.loading_message = false
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					console.log('Messaging Store (getMessages) failed:' + e.response.data.message)
				})
		},
		getMoreMessages() {
			this.loading_message = true
			this.messages_pagination.current_page++
			let queryParams = _gHlp.generateQueryParams({
				paginate: 10,
				page: this.messages_pagination.current_page,
				orderBy: {
					message_id: 'desc'
				},
				search: {
					message_group_id: this.selected_group.group_id,
					message_from_date: this.showOnlyFromDate()
				}
			})

			let url = `${services.messaging}messages?${queryParams}`;
			axios.get(url, { headers: getHeader() })
				.then(res => {
					if (!_gHlp.isEmpty(res.data)) {
						this.messages = this.messages.concat(res.data.data)
						this.messages_pagination = res.data.meta
					}
					this.loading_message = false
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Messaging Store (getMoreMessages) failed:' + e.response.data.message)
				})
		},
		setReplyTo(message_id) {
			this.replying_to = message_id
		},
		resetReplyTo() {
			this.replying_to = null
		},
		resetMessages() {
			this.messages = [];
			this.replying_to = null
			this.edit_message = null
			this.selected_group = null
		},
		updateLoadingMessage(boolean) {
			this.loading_message = boolean
		},
		updateLoadingSearch(boolean) {
			this.loading_search = boolean
		},
		setEditMessage(message) {
			this.edit_message = message
		},
		showOnlyFromDate() {
			if (_gHlp.isEmpty(this.selected_group)) return null;
			if (_gHlp.getValue(this.message_profile, 'show_all_messages', false)) return null;

			const activeMsgGroupSuperAdminIds = _gAuth.activeCorpMsgGroupSuperAdminIds();
			if (_gAuth.isCorporateOwner() || activeMsgGroupSuperAdminIds.includes(_gAuth.activeUserId())) return null

			let activeUserId = _gAuth.activeUserId();
			let participant = this.selected_group.group_participants.find(o => { return o.participant_user_id == activeUserId })

			if (_gHlp.isEmpty(participant)) return _gHlp.getCurrentDateTime();
			return participant.gmp_join_date;
		},
		getSuggestionList(query) {
			if (_gHlp.isEmpty(this.selected_group)) return [];
			const participantNames = this.selected_group.group_participants.map(participant => participant.participant_fullname)
			const filteredNames = participantNames.filter((item) =>
				item.toLowerCase().includes(query.toLowerCase())
			);

			if (filteredNames.length > 0) {
				return filteredNames.slice(0, 10);
			} else {
				return [];
			}
		},
		createInfoMessage(type, group_id, user_id) {
			let content = null;
			let user = this.available_user_list.find((o) => { return o.id == user_id })
			let activeUser = _gAuth.activeUser()

			if (type == "ADD_MEMBER") {
				if (_gHlp.isEmpty(user)) return false;
				content = user.name + " has been add into group by " + activeUser.name + " at " + _gHlp.getCurrentDateTime()
			} else if (type == "REMOVE_MEMBER") {
				if (_gHlp.isEmpty(user)) return false;
				content = user.name + " has been remove from group by " + activeUser.name + " at " + _gHlp.getCurrentDateTime()
			} else if (type == "NEW_GROUP") {
				content = "Group has been created by " + activeUser.name + " at " + _gHlp.getCurrentDateTime()
			} else if (type == "NEW_PRIVATE") {
				content = "Private chat has been created by " + activeUser.name + " at " + _gHlp.getCurrentDateTime()
			} else if (type == "UPDATE_GROUP") {
				content = "Group setting has been update by " + activeUser.name + " at " + _gHlp.getCurrentDateTime()
			} else if (type == "EXIT_GROUP") {
				content = activeUser.name + " exit group at " + _gHlp.getCurrentDateTime()
			}

			if (_gHlp.isEmpty(content)) return false;
			const createData = {
				message_group_id: group_id,
				message_participant_id: _gAuth.activeMsgParticipantId(),
				message_reply_id: null,
				message_content: content,
				message_application_code: _gAuth.appCode(),
				message_is_info: 1,
				message_mentions: null
			}
			axios.post(services.messaging + 'message', createData, { headers: getHeader() })
		},

		//MESSAGE BOX SUMMARY
		getNewBundleKey() {
			let t = Math.round(new Date().getTime() / 1000)
			if (_gHlp.isEmpty(this.message_profile)) return 'messaging_o'
			return this.message_profile.message_group_bundle_key + '_' + _gAuth.activeUserId() + '_' + t
		},
		generateMessageProfile(type, profileData, bundle_key, show_from_at) {
			let show_all_messages = false
			let auto_add_participant = false
			let exclude_users = []
			if(_gAuth.isAppSas()){
				show_all_messages = true
				auto_add_participant = true
				exclude_users = []
			}
			switch (type) {
				case 'customer': {
					return {
						type: type,
						profile_name: profileData.name,
						lead_id: !_gHlp.isEmpty(profileData.lead) ? profileData.lead.lead_id : (!_gHlp.isEmpty(profileData.lead_id) ? profileData.lead_id : ''),
						customer_id: !_gHlp.isEmpty(profileData.customer_id) ? profileData.customer_id : (!_gHlp.isEmpty(profileData.customer) ? profileData.customer.customer_id : ''),
						message_group_bundle_key: bundle_key,
						show_from_at: null,
						show_all_messages: show_all_messages,
						auto_add_participant: auto_add_participant,
						exclude_users: exclude_users,
					}
					break;
				}
				case 'proposal': {
					return {
						type: type,
						profile_name: profileData.customer_detail.name,
						lead_id: profileData.customer_detail.lead_id,
						customer_id: profileData.customer_detail.customer_id,
						proposal_id: profileData.psal_id,
						message_group_bundle_key: bundle_key,
						show_from_at: null,
						show_all_messages: show_all_messages,
						auto_add_participant: auto_add_participant,
						exclude_users: exclude_users,
					}
					break;
				}
				case 'case': {
					return {
						type: type,
						profile_name: profileData.name,
						lead_id: !_gHlp.isEmpty(profileData.lead) ? profileData.lead.lead_id : (!_gHlp.isEmpty(profileData.lead_id) ? profileData.lead_id : ''),
						customer_id: !_gHlp.isEmpty(profileData.customer_id) ? profileData.customer_id : (!_gHlp.isEmpty(profileData.customer) ? profileData.customer.customer_id : ''),
						message_group_bundle_key: bundle_key,
						show_from_at: null,
						prod_id: profileData.prod_id,
						prod_type: profileData.prod_type,
						show_all_messages : show_all_messages,
						auto_add_participant : auto_add_participant,
						exclude_users : exclude_users,
					}
					break;
				}
				case 'loan_case':
				case 'invinity_customer': {
					return {
						type: type,
						profile_name: profileData.name,
						lead_id: null,
						customer_id: _gHlp.getValue(profileData, 'sas_im2u_id', _gHlp.getValue(profileData, 'customer_id', _gHlp.getValue(profileData, 'im2u_id', _gHlp.getValue(profileData, 'id')))),
						message_group_bundle_key: bundle_key,
						alternative_bundle_key: bundle_key,
						show_from_at: null,
						show_all_messages: show_all_messages,
						auto_add_participant: auto_add_participant,
						exclude_users: exclude_users,
					}
					break;
				}
				case 'lead': {
					let is_reshuffe_lead = false;
					if (_gAuth.isAppSas()) {
						let channelIds = _gAuth.activeCorpSettings('lead_reassign_only_channel_ids', [])
						let channel_id = _gHlp.getValue(profileData, 'channel_id');
						let msg_txt = _gHlp.getValue(profileData, 'message');

						if ((msg_txt == 'lead-slack') || channelIds.includes(channel_id)) {
							const assignedUsers = _gHlp.getValue(profileData, 'lead_assignments', []);
							let includeUserId = _gAuth.activeUserId()
							if (!useLeadStore().checkIsOwnLead(profileData)) {
								includeUserId = _gHlp.getValue(profileData, 'assign_to');
							}

							let exUsers = assignedUsers.filter(itm => itm.user_id != includeUserId);
							exclude_users = (!_gHlp.isEmpty(exUsers)) ? exUsers.map(itm => itm.user_id) : [];
							is_reshuffe_lead = true;
						}
					}

					return {
						type: type,
						profile_name: profileData.name,
						lead_id: !_gHlp.isEmpty(profileData.lead_id) ? profileData.lead_id : (!_gHlp.isEmpty(profileData.lead) ? profileData.lead.lead_id : ''),
						customer_id: !_gHlp.isEmpty(profileData.customer_id) ? profileData.customer_id : (!_gHlp.isEmpty(profileData.customer) ? profileData.customer.customer_id : ''),
						message_group_bundle_key: bundle_key,
						show_from_at: show_from_at,
						show_all_messages: show_all_messages,
						auto_add_participant: auto_add_participant,
						exclude_users: exclude_users,
						is_reshuffe_lead: is_reshuffe_lead,
						is_lead_owner: useLeadStore().checkIsOwnLead(profileData),
					}
					break;
				}	
				case 'banker': {
					return {
						type: type,
						profile_name: profileData.product_details.prod_customer_name + ' - ' + profileData.prod_bnk_name,
						lead_id:  null,
						prod_id: profileData.product_details.prod_id,
						prod_type: profileData.product_details.prod_type,
						prod_bnk_id: profileData.prod_bnk_id,
						customer_id: profileData.product_details.prod_customer_id,
						message_group_bundle_key: bundle_key,
						show_from_at: show_from_at,
						show_all_messages : show_all_messages,
						auto_add_participant : auto_add_participant,
						exclude_users : exclude_users, 
						banker_user: profileData.prod_bnk_banker_detail
					}
					break;
				}
				default: {
					return {
						type: type,
						profile_name: profileData.name,
						lead_id: !_gHlp.isEmpty(profileData.lead_id) ? profileData.lead_id : (!_gHlp.isEmpty(profileData.lead) ? profileData.lead.lead_id : ''),
						customer_id: !_gHlp.isEmpty(profileData.customer_id) ? profileData.customer_id : (!_gHlp.isEmpty(profileData.customer) ? profileData.customer.customer_id : ''),
						message_group_bundle_key: bundle_key,
						show_from_at: show_from_at,
						show_all_messages: show_all_messages,
						auto_add_participant: auto_add_participant,
						exclude_users: exclude_users,
					}
					break;
				}
			}
		},
		getProfileBundleKey(type, model) {
			let bundle_key = ''
			if (!_gHlp.isEmpty(model)) {
				//IF EMPTY GET BY PROFILE TYPE
				if (type == 'customer') {
					//IF EMPTY GENERATE WITH LEAD ID
					if (!_gHlp.isEmpty(model.lead_id)) {
						bundle_key = 'messaging_l_' + model.lead_id
					}

					//IF STILL EMPTY DEFAULT USE CUSTOMER ID
					if (_gHlp.isEmpty(bundle_key)) {
						bundle_key = 'messaging_c_' + model.customer_id
					}
				} else if (type == 'cases') {

					//IF EMPTY GET FROM CUSTOMER BUNDLE
					if (!_gHlp.isEmpty(model.messaging_data)) {
						if (!_gHlp.isEmpty(model.messaging_data.lead_id)) {
							bundle_key = 'messaging_l_' + model.messaging_data.lead_id
						} else if (!_gHlp.isEmpty(model.messaging_data.message_group_bundle_key)) {
							bundle_key = model.messaging_data.message_group_bundle_key
						}
					}

					//IF STILL EMPTY DEFAULT USE CUSTOMER ID
					if (_gHlp.isEmpty(bundle_key)) {
						bundle_key = 'messaging_c_' + model.prod_customer_id
					}

				} else if (type == 'proposal') {
					//IF EMPTY GET FROM CUSTOMER BUNDLE
					if (!_gHlp.isEmpty(model.customer_detail)) {
						//IF EMPTY GENERATE WITH LEAD ID FROM CUSTOMER DETAIL
						if (!_gHlp.isEmpty(model.customer_detail.lead_id)) {
							bundle_key = 'messaging_l_' + model.customer_detail.lead_id
						}

						if (_gHlp.isEmpty(bundle_key) && !_gHlp.isEmpty(model.customer_detail.message_group_bundle_key)) {
							bundle_key = model.customer_detail.message_group_bundle_key
						}
					}

					if (_gHlp.isEmpty(bundle_key)) {
						bundle_key = 'messaging_c_' + model.customer_detail.customer_id
					}
				} else if (type == 'invinity_customer' || type == 'loan_case') {
					//IF EMPTY GET FROM CUSTOMER BUNDLE
					bundle_key = (!_gHlp.isEmpty(model.message_group_bundle_key)) ? model.message_group_bundle_key : null;
					if (_gHlp.isEmpty(bundle_key)) {
						bundle_key = 'messaging_c_' + _gHlp.getValue(model, 'sas_im2u_id', _gHlp.getValue(model, 'customer_id', _gHlp.getValue(model, 'im2u_id', _gHlp.getValue(model, 'id'))))
					}
				}
				else if (type == 'banker') {
					if (!_gHlp.isEmpty(model)) {
						if (!_gHlp.isEmpty(model.prod_bnk_prod_id) && !_gHlp.isEmpty(model.prod_bnk_id)) {
							bundle_key = 'messaging_b_' + model.prod_bnk_id;
						} 
					}
				}
				else {
					bundle_key = 'messaging_l_' + model.lead_id
				}


				//REPAIR BUNDLE
				let arr_b_key = bundle_key.split('_');
				if (arr_b_key.length >= 3) {
					bundle_key = arr_b_key[0] + '_' + arr_b_key[1] + '_' + arr_b_key[2];
				} else {
					bundle_key = arr_b_key.join('_');
				}
			}
			return bundle_key;
		},
		getProfileMessageBudleKeys(type, profiles) {
			let bundle_keys = []
			let bundle_key = ''
			if (!_gHlp.isEmpty(profiles)) {
				for (const key in profiles) {
					const model = profiles[key];
					if (_gHlp.isEmpty(model)) continue;

					bundle_key = this.getProfileBundleKey(type, model)
					if (!_gHlp.isEmpty(bundle_key)) {
						bundle_keys.push(bundle_key)
					}

				}
			}
			return bundle_keys;
		},
		async getProfileListMessagesSummaries(type, profiles) {
			this.group_message_summaries = [];
			let bundle_keys = this.getProfileMessageBudleKeys(type, profiles)
			this.group_message_summaries = await this.getListMessagesSummaries(bundle_keys);
			return this.group_message_summaries;
		},
		getListMessagesSummaries(bundle_keys) {
			return new Promise((resolve, reject) => {
				if (_gHlp.isEmpty(bundle_keys)) {
					resolve([]);
				} else {
					let params = _gHlp.generateQueryParams({
						bundle_keys: bundle_keys,
						show_external: true,
						participant_id: _gAuth.activeMsgParticipantId()
					})
					axios.get(services.messaging + 'group-message/list-summary?' + params, { headers: getHeader() }).then(resp => {
						resolve(resp.data);
					}).catch(err => {
						reject(err);
					})

				}
			});
		},
		getMessageBoxSummary(bundle_key) {
			if (_gHlp.isEmpty(this.group_message_summaries)) return {}
			return this.group_message_summaries.find((o) => { return o.bundle_key === bundle_key })
		},


		/**
		 *[===========EMAIL MESSAGE FEATURE===========]
		 *PUT ALL CODE ABOUT EMAIL MESSAGE BELOW DON'T MIX WITH OTER MESSAGE FEATURE
		 */
		async sendEmail(emailData) {
			try {
				const response = await axios.post(services.messaging + 'send-email', emailData, { headers: getHeader() });
				return response.data;
			} catch (error) {
				console.error('Failed to send email:', error);
			}
		},
		sendEmailAttachment(temp_key, toEmails, params={}, attcIds = []) {
			return new Promise( async (resolve, reject) => {
				let tmplt = await useNotificationStore().fetchEmailTemplate(temp_key);
				let subject = _gHlp.getValue(tmplt, 'notif_temp_title',_gHlp.getValue(defaultEmailTemplates, temp_key+'.subject',null));
				let content = _gHlp.getValue(tmplt, 'notif_temp_message',_gHlp.getValue(defaultEmailTemplates, temp_key+'.content',null));
				
				const recipients = (_gHlp.getValue(tmplt,'notif_temp_receiver','')).split(',').map(email => email.trim());
				let emails = !_gHlp.isEmpty(toEmails) ? toEmails : recipients;
				if(_gHlp.isEmpty(emails) || _gHlp.isEmpty(content)){
					reject({error: 'template not found'})
				}
				if(!_gHlp.isEmpty(params)){
					for (let key in params) {
						content = content.replace('{'+key+'}', params[key]);
					}
				}
				//IF NO ATTACHMENT DIRECT TO MESSAGE SERVICE
				if(_gHlp.isEmpty(attcIds)){
					let mailCntn = {
						to: emails, // Array of email addresses
						subject: subject,
						body: content
					}
					
					axios.post(services.messaging + 'send-email', mailCntn, { headers: getHeader() }).then(resp => {
						resolve(resp.data);
					}).catch(err => {
						reject(err);
					})
				}else{
					//IF HAVE ATTACHMENT SEND TO MESSAGE SERVICE VIA ATTACHMENT SERVICE
					if(Array.isArray(emails)){
						for (let i = 0; i < emails.length; i++) {
							const toMail = emails[i];
							useAttachmentStore().sendToEmail(toMail,attcIds,subject,content)
						}	
						resolve('OK');
					}else{
						useAttachmentStore().sendToEmail(emails,attcIds,subject,content)
						resolve('OK');
					}
				}
			});
		},

		/**
		 *[===========SMS MESSAGE FEATURE===========]
		 *PUT ALL CODE ABOUT SMS MESSAGE BELOW DON'T MIX WITH OTER MESSAGE FEATURE
		 */
		async getSmsTemplates(params = {}) {
			let stringParams = '';
			if (Object.keys(params).length > 0) {
				stringParams = _gHlp.generateQueryParams(params)
			}
			const smsTemplates = await axios.get(services.messaging + 'sms-template?' + stringParams, { headers: getHeader() }).then(resp => {
				return resp.data.data;
			}).catch(err => {
				_gNotif.errorFunction(err)
			})

			this.sms_template_list = smsTemplates

			return smsTemplates
		},
		async getSmsLogs(data) {
			const smsLogs = await axios.get(services.messaging + 'sms?' + data, { headers: getHeader() }).then(resp => {
				return resp.data.data;
			}).catch(err => {
				_gNotif.errorFunction(err)
			})

			return smsLogs
			// return null
		},
		async sendSms(data) {
			let result = await axios.post(services.messaging + 'sms', data, { headers: getHeader() }).then(resp => {
				return resp.data
			}).catch(err => {
				_gNotif.errorFunction(err)
				return false;
			})

			return result;
		}

		/**
		 *[===========NOTIFICATION MESSAGE FEATURE===========] (TECH DEBT)
		 *PUT ALL CODE ABOUT NOTIFICATION MESSAGE BELOW DON'T MIX WITH OTER MESSAGE FEATURE
		 */
	}
})